import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Fri Jul 27 2018
 * @author BPo
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import * as React from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { User } from '@logio/common-be-fe';
import translate, { getPath } from '../../i18n/translate';
import Icon, { IconType, IconColor } from '../../../components/media/Icon';
import rootStore from '../../../shared/stores/RootStore';
import { StoreName } from '../../../shared/stores/StoreName';

var UserMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UserMenu, _React$Component);

  function UserMenu(props) {
    var _this;

    _classCallCheck(this, UserMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserMenu).call(this, props));
    _this.keycloakStore = rootStore.getStore(StoreName.Keycloak);
    _this.onAccountClick = _this.onAccountClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onLogoutClick = _this.onLogoutClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }
  /**
   * Redirects to account
   */


  _createClass(UserMenu, [{
    key: "onAccountClick",
    value: function onAccountClick() {
      this.keycloakStore.keycloak.accountManagement();
    }
    /**
     * Redirects to logout.
     */

  }, {
    key: "onLogoutClick",
    value: function onLogoutClick() {
      this.keycloakStore.logout();
    }
    /**
     * Get current user profile
     */

  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "header-icon header-dark header-user header-switch"
      }, React.createElement(Icon, {
        className: "header-user-icon",
        iconType: IconType.user,
        iconHeight: 30,
        iconColor: IconColor.Inverse
      }), React.createElement("div", {
        className: "header-switch-menu"
      }, this.renderAccount(), !this.props.isSystemAdmin && this.renderSubstitution(), this.renderLogout()));
    }
  }, {
    key: "renderAccount",
    value: function renderAccount() {
      return React.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.onAccountClick
      }, React.createElement("div", null, "User profile"), React.createElement("span", null, "(", this.profile.substitutedUser ? "".concat(this.profile.firstName, " ").concat(this.profile.lastName) : "".concat(this.profile.username), ")"));
    }
  }, {
    key: "renderSubstitution",
    value: function renderSubstitution() {
      return React.createElement(Link, {
        to: getPath(this.props.substitutionLink)
      }, React.createElement("div", null, "Switch User ", this.profile.substitutedUser ? "- ".concat(translate('Active')) : null), this.profile.substitutedUser && React.createElement("span", null, "(", this.profile.substitutedUser.firstName, " ", this.profile.substitutedUser.lastName, ")"));
    }
  }, {
    key: "renderLogout",
    value: function renderLogout() {
      return React.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.onLogoutClick
      }, "Logout");
    }
  }, {
    key: "profile",
    get: function get() {
      return this.keycloakStore.profileStore.profile;
    }
  }]);

  return UserMenu;
}(React.Component);

__decorate([computed, __metadata("design:type", User), __metadata("design:paramtypes", [])], UserMenu.prototype, "profile", null);

UserMenu = __decorate([observer, __metadata("design:paramtypes", [Object])], UserMenu);
export { UserMenu };